<div class="container">
    <form [formGroup]="form">
        <div class="row ms-5 mt-5" [class.has-danger]="!comments?.valid && comments?.touched">
            <label class="col-md-3 required-label"><strong>Note:</strong></label>
            <div class="col-md-8">
                <textarea [formControl]="comments"
                      formControlName="comments"
                      name="comments"
                      cols="30"
                      rows="5"
                      class="form-control"></textarea>
                <div *ngIf="comments?.hasError('required') && comments?.touched" class="alert alert-danger mt-2">
                    Comment is required
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-secondary m-2 pull-right" [disabled]="isProcessing" (click)="onClickCancel()">Cancel
        </button>
        <button type="button" class="btn btn-primary m-2 px-1 pull-right" [disabled]="isProcessing" (click)="onClickConfirmInfoRequest()">Confirm
        </button>
    </form>
</div>
